var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-advantages" }, [
    _c("img", {
      staticClass:
        "home-advantages__outer-img home-advantages__outer-img--left",
      attrs: { src: _vm.imgLeft, alt: "Image Left" }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass:
        "home-advantages__outer-img home-advantages__outer-img--right",
      attrs: { src: _vm.imgRight, alt: "Image Right" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "home-advantages__title-block" }),
    _vm._v(" "),
    _c("div", {
      staticClass: "home-advantages__title",
      domProps: { innerHTML: _vm._s(_vm.title) }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "home-advantages__list-block" }, [
      _c("ul", [
        _c("li", { domProps: { innerHTML: _vm._s(_vm.entry1) } }),
        _vm._v(" "),
        _c("li", { domProps: { innerHTML: _vm._s(_vm.entry2) } }),
        _vm._v(" "),
        _c("li", { domProps: { innerHTML: _vm._s(_vm.entry3) } }),
        _vm._v(" "),
        _c("li", { domProps: { innerHTML: _vm._s(_vm.entry4) } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }